import PropTypes from 'prop-types'
import Assignment from 'inbox/assignment'
import { isEmpty as isEmptyObject } from 'util/objects'

const t = PropTypes.shape({
  assigned_group_id: PropTypes.string,
  assignee: PropTypes.object, // TODO: actor type
  assignment: Assignment.t,
  attachments: PropTypes.object, // TODO: attachment type
  bcc: PropTypes.array, // TODO: arrayOf actor
  body: PropTypes.string,
  bodyAuthor: PropTypes.object, // TODO: actor type
  bodyParsed: PropTypes.string,
  cc: PropTypes.array, // TODO: arrayOf actor
  conversationType: PropTypes.string,
  customer: PropTypes.object, // TODO: actor type
  draftBodyPlainText: PropTypes.string,
  id: PropTypes.string,
  isForwarding: PropTypes.bool,
  labels: PropTypes.array, // TODO: arrayOf label
  mailboxId: PropTypes.string,
  noteDraftBodyPlainText: PropTypes.string,
  priority: PropTypes.string, // TODO: priority enum type
  starred: PropTypes.bool,
  state: PropTypes.string, // TODO: state enum type
  stateLabel: PropTypes.string,
  ticketId: PropTypes.string,
  title: PropTypes.string,
  titleLabel: PropTypes.string,
  to: PropTypes.object, // TODO: actor type
})

function isEmpty(draft) {
  const { attachments, body } = draft

  const hasNoBody = !body || body === ''
  const hasNoAttachments = !attachments || isEmptyObject(attachments)

  return hasNoBody && hasNoAttachments
}

export default {
  t,
  isEmpty,
}
